import React from "react";

import classNames from "classnames";
import { MenuItem, Paper, MenuList } from "material-ui";
import { withStyles } from "material-ui/styles";
import { isAdmin, isCustomerAdmin } from "utils/formatter";
import { Popper } from "react-popper";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Grow from "material-ui/transitions/Grow";

const styles = {
  hide: {
    display: "none"
  },
  popperClose: {
    pointerEvents: "none"
  }
};

const HeaderMenu = props => {
  return (
    <Popper
      placement="bottom-end"
      eventsEnabled={props.open}
      style={{ zIndex: 999 }}
      className={classNames({ [props.classes.popperClose]: !props.open })}
    >
      <ClickAwayListener onClickAway={props.closeMenu}>
        <Grow
          in={props.open}
          id={props.menuId}
          style={{
            transformOrigin: "0 0 0",
            left: -30
          }}
        >
          <Paper>
            <MenuList role="menu">
              {isAdmin() && (
                <MenuItem
                  onClick={() => {
                    props.closeMenu();
                    props.historyPush("/customer_list");
                  }}
                >
                  顧客一覧
                </MenuItem>
              )}

              {isAdmin() && (
                <MenuItem
                  onClick={() => {
                    props.closeMenu();
                    props.historyPush("/admin_list");
                  }}
                >
                  管理者一覧
                </MenuItem>
              )}

              {isCustomerAdmin() && (
                <MenuItem
                  onClick={() => {
                    props.closeMenu();
                    props.historyPush("/survey_list");
                  }}
                >
                  ホーム
                </MenuItem>
              )}

              <MenuItem
                onClick={() => {
                  props.closeMenu();
                  props.historyPush("/manual_download");
                }}
              >
                マニュアル
              </MenuItem>

              <MenuItem
                onClick={() => {
                  props.closeMenu();
                  props.historyPush("/password_update");
                }}
              >
                パスワード変更
              </MenuItem>

              <MenuItem onClick={() => props.handleLogout()}>
                ログアウト
              </MenuItem>
            </MenuList>
          </Paper>
        </Grow>
      </ClickAwayListener>
    </Popper>
  );
};

export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.jsx